import React from 'react'
import styles from "./styles/LoadingsIndicator.module.css"

export const LoadingIndicator = () => {
    return (
        <div className = {styles.loader}>
            
        </div>
    )
}
